export const getRadiusByDmaRank = dmaRank => {
  if (dmaRank <= 10) {
    return 25;
  } else if (dmaRank <= 53) {
    return 50;
  }
  return 100;
};
